import React, { Fragment, useEffect, useRef } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import shaka from 'shaka-player';

import NewSongModal from './new-song-modal';
import SongList from './song-list';
import config from 'client/shared/config'

const ShakaPlayer = () => {
	const videoRef = useRef(null);
  
	useEffect(() => {
		const video = videoRef.current;
		const player = new shaka.Player();
		
		const getAndAttachVideo = async () => {
			await player.attach(video);
		}

		if (!shaka.Player.isBrowserSupported()) {
			console.error("Shaka Player is not supported in this browser.");
			return;
		}

		getAndAttachVideo();

		player.addEventListener("error", (event) => {
			console.error("Shaka Error:", event.detail);
		});

		return () => {
			player.destroy(); // Cleanup on unmount
		};
	}, []);
  
	return <video
			controls
			playsInline
			autoPlay={false}
			ref={videoRef}
			style={{
				width: '100%',
				backgroundColor: '#f1f3f4',
				height: '92px'
			}}
			crossOrigin="anonymous"
		/>;
};

@inject('songsStore', 'artistStore', 'userStore')
@observer
class Music extends React.Component {
	constructor (props) {
		super(props);

		const { artistStore, userID, rowUserID } = this.props;
		this.artist = artistStore.getArtistByUserID(userID ? userID : rowUserID);

		this.state = {
			currentSong: null,
			player: null
		};
		this.videoElement = React.createRef();
	}

	componentDidMount() {
		// Install Shaka Player polyfills
		shaka.polyfill.installAll();

		// Initialize Shaka Player
		const player = new shaka.Player(this.videoElement.current);
		this.getAndAttachVideo(player, this.videoElement.current);
		player.addEventListener('error', this.onShakaError);
		player.unload();
		this.setState({ player });
	}

	componentWillUnmount() {
		if (this.state.player) {
			this.state.player.destroy();
		}
	}

	@autobind
	onShakaError(error) {
		console.error('Shaka Player Error:', error);
	}

	@autobind
	async getAndAttachVideo (player, video) {
		await player.attach(video);
	}

	@autobind
	async onSongClick(song) {
		this.setState({ currentSong: song });
		const { songsStore } = this.props;
		songsStore.activeSongRowID = song.id;
		
		try {

			const player = new shaka.Player();
			await player.attach(document.querySelector('video'));

			player.getNetworkingEngine().registerRequestFilter((type, request) => {
				const reqTypes = shaka.net.NetworkingEngine.RequestType;
				// Apply this setting to manifest and segment requests
				if (type === reqTypes.MANIFEST || type === reqTypes.SEGMENT) {

					// Allow credentials to be sent with cross-site requests
					request.allowCrossSiteCredentials = true;
				}
			});
			
			await player.load(song.streamingPath);
			document.querySelector('video').play();
		} catch (error) {

			console.error('Error loading manifest:', error);
		}
	}

	render () {
		const { optionsTheme } = this.props;

		return (
			<Fragment>
			<div onClick={ this.onClick }>
				<div className="grid-x" style={{alignItems: 'center'}}>
					<div className="cell small-2">{ this.renderMusicModal() }</div>
				</div>
				<div className="grid-x">
					<div className="cell">&nbsp;</div>
				</div>
				<div className="grid-x">
					<div className="cell small-12">
						{/* <h4 className="subheader">Tracks</h4> */}
					</div>
					<div className="cell small-12">
						<SongList
							trackListMode
							artist={ this.artist }
							listKey="tracksList"
							optionsTheme={ optionsTheme }
							onSongClick={ this.onSongClick }
						/>
					</div>
				</div>
			</div>
				<div className="small-mzdp-container" style={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					width: '100%',
					backgroundColor: '#212020',
					zIndex: 1000
				}}>
					<div style={{display: !!this.state.currentSong ? 'block' : 'none' }}>
						<ShakaPlayer />
					</div>
				</div>
			</Fragment>
		);
	}

	renderMusicModal () {
		const { rowUserID, userStore, artistStore } = this.props;
		const artist = artistStore.loggedInArtist

		return (
			<div className="grid-x align-bottom">
				<div className="cell small-12">
					<NewSongModal artist={ artist } rowUserID={ rowUserID }/>
				</div>
			</div>
		);
	}

	@autobind
	onClick ({ target: { classList } }) {
		if (classList.contains('button') || classList.contains('delete-button-container')) {
			return;
		}

		const { songsStore } = this.props;
		songsStore.activeSongRowID = null;
	}
}

export default Music;
